import { Injectable } from "@angular/core";
import * as moment from 'moment-timezone';
import { TranslateService } from "ng2-translate";

@Injectable()
export class CommonService {
    public userType: number;
    public username: string; // username base64Util
    public userNameFull: string;
    public password: string;
    public flagSwitch: boolean = false;

    // disable verify phone number
    public disableVerify: boolean = false;

    // flag verify phone number
    public flagVerifyNumber: number;

    constructor(private translate:TranslateService){}

    // numberWithCommas(x: number) : string {
    //     const num = Number(x).toFixed(2);
    //     return num.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // }
    numberWithCommas(x: number): string {
        // Kiểm tra nếu có phần thập phân
        const hasDecimal = x % 1 !== 0;
        // Sử dụng toFixed dựa trên điều kiện
        const num = hasDecimal ? Number(x).toFixed(2) : Number(x).toFixed(0);
        // Thêm dấu phẩy vào phần nguyên
        return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    

    /**
     * @param dateFormat
     * @param typeFormat => ex: HH:mm:ss, DD/MM/YYYY
     */
    convertTimeZoneVN(dateFormat, typeFormat) {
        let timezoneObj = moment(dateFormat);
        return timezoneObj.tz('Asia/Ho_Chi_Minh').format(typeFormat);
    }

    checkUserTestIBC2() {
        let users = ['demoaccount', 'demoaccount01', 'qtestacc66'];
        let flag = false;
        if (this.userNameFull && users.indexOf(this.userNameFull) >= 0) {
            flag = true;
        }
        return flag;
    }

    languageChange(selectedLanguage: string = 'vi') {
        // console.log('Language changed to:', selectedLanguage);
        // Cập nhật ngôn ngữ của ứng dụng tại đây (nếu có)
        localStorage.setItem('langcode',selectedLanguage);
        this.translate.setDefaultLang(selectedLanguage);
        this.translate.use(selectedLanguage);
      }
}


// WEBPACK FOOTER //
// ./src/services/common.service.ts